import { api } from "../../api/axios";
import type { TAddCommentRequest, TLessonCommentsRequest } from "../types";

export const addComment = async (params: TAddCommentRequest["payload"]) => {
  const { data } = await api.post<TAddCommentRequest["response"]>(
    "/v1/user/comments",
    params
  );
  return data;
};

export const getLessonComments = async (
  params: TLessonCommentsRequest["payload"]
) => {
  const { lessonId, ...queryParams } = params;
  const { data } = await api.get<TLessonCommentsRequest["response"]>(
    `/v1/user/comments/lesson/${lessonId}`,
    { params: queryParams }
  );
  return data;
};
